import module from 'nominas/sumario/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominasSumarioComponent {
  proyectoId
  nominaId
  tipoNominaId
  regimenFiscalId
  configuracion = false
  catalogos = {}

  constructor ($q, $catalogos, NominasCatalogoRegimenFiscal, NominasCatalogoTipoNomina) {
    this.$q = $q
    this.$catalogos = $catalogos
    this.NominasCatalogoRegimenFiscalService = NominasCatalogoRegimenFiscal
    this.NominasCatalogoTipoNominaService = NominasCatalogoTipoNomina
  }

  $onInit () {
    this.promise = this.$q.all([
        this.$catalogos.get('empresas')
          .then((data) => data.map((item) => ({id: item.ID_Empresa, descripcion: item.Nombre})))
          .then((data) => (this.catalogos.proyectos = orderBy(data, ['descripcion']))),
        this.NominasCatalogoRegimenFiscalService.get()
          .then(({data}) => (this.catalogos.regimenFiscales = data)),
        this.NominasCatalogoTipoNominaService.get()
          .then(({data}) => (this.catalogos.tipoNomina = data.filter((item) => item.id !== 6))),
      ])
      .then(() => (this.configuracion = !!this.nominaId))
  }

  seleccionar (data) {
    this.proyectoId = data.proyecto_id
    this.nominaId = data.nomina_id
    this.tipoNominaId = data.tipo_nomina_id
    this.regimenFiscalId = data.regimen_fiscal_id
    this.configuracion = true
  }
}

module.component('nominasSumarioAgregar', {
  controller: NominasSumarioComponent,
  template,
  bindings: {
    proyectoId: '<',
    nominaId: '<',
    regimenFiscalId: '<',
    tipoNominaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/agregar/component.js